import { delay } from 'pano-utils';
import { queryClient, queryKeys } from '@queryClient';

async function refetchLibSpace() {
  await delay(2000);
  return queryClient.refetchQueries(queryKeys.libSpace, { active: true });
}

export default refetchLibSpace;
